import { render, staticRenderFns } from "./Vue3Syntax.vue?vue&type=template&id=35c01122&scoped=true"
import script from "./Vue3Syntax.vue?vue&type=script&lang=js"
export * from "./Vue3Syntax.vue?vue&type=script&lang=js"
import style0 from "./Vue3Syntax.vue?vue&type=style&index=0&id=35c01122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c01122",
  null
  
)

export default component.exports